import { useAtomValue } from 'jotai';

import isCartOpenAtom from './isCartOpenAtom';

const useIsCartOpen = () => {
  const isCartOpenValue = useAtomValue(isCartOpenAtom);
  return isCartOpenValue;
};

export default useIsCartOpen;
